module.exports = __webpack_public_path__ + "iq.a1520bca.svg";